import { useState } from "react";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import { useAuth } from "../../Providers/AuthProvider";
import { InsertServiceList } from "../../services/InsertServiceList";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { LoadingButton } from "@mui/lab";
import { goToTop } from "../../utiles/GotoTop";

const DefineListWithoutFormik = ({
  label,
  list,
  suggested,
  deleteServiceListHandler,
  ChangeSubmitTracker,
}) => {
  const [value, setValue] = useState(null);

  const [key, setKey] = useState(Math.random());
  const [insertLoad, setInsertLoad] = useState(false);

  const { stateAuth } = useAuth();
  let params = useParams();
  const packageId = params.id;

  const changeHanler = (event, newValue) => {
    setValue(newValue);
  };

  const submitHandler = () => {
    const requestData = {
      CurrencyRate: "",
      currencyTypeId: "",
      DisplayPrice: "",
      Price: "",
      DisplayPercent: "",
      ServicesId: value.ServicesId,
      OptionalFlag: "0",
      PublishFlag: "1",
      PackageId: packageId,
    };
    const InsertService = async () => {
      setInsertLoad(true);
      const header = {
        headers: {
          token: stateAuth,
        },
      };

      try {
        const { data } = await InsertServiceList(requestData, header);
        ChangeSubmitTracker();
        setKey(Math.random());
        setInsertLoad(false);
        toast.success(`خدمات تور با موفقیت ثبت شد.`);
        goToTop();
      } catch (error) {
        setInsertLoad(false);
        toast.success(`ثبت خدمات ناموفق بود.`);
        goToTop();
      }
    };
    InsertService();
    setValue(null);
  };

  const deleteListHandler = (id) => {
    deleteServiceListHandler(id);
  };

  return (
    <>
      <div className="w-full flex flex-wrap min-h-[40px]">
        <label className="mb-2 text-sm w-full">{label}</label>

        <Autocomplete
          key={key}
          id="free-solo-demo"
          className="h-10 flex-[2] rounded focus:outline-lightGreenKite"
          value={value}
          onChange={changeHanler}
          freeSolo
          options={suggested}
          getOptionLabel={(option) => option.title}
          renderInput={(params) => {
            return <TextField {...params} />;
          }}
        />
        <LoadingButton
          sx={{
            backgroundColor: "#73c9ca",
            border: "none",
            color: "#fff",
            fontSize: "23px",
            padding: 0,
            height: "2.5rem",
            width: "2.75rem",
            "&:hover": {
              backgroundColor: "#73c9ca",
              border: "none",
              color: "#fff",
            },
          }}
          onClick={submitHandler}
          loading={insertLoad}
          variant="outlined"
          type="button"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            className="w-6 h-6"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M12 4.5v15m7.5-7.5h-15"
            />
          </svg>
        </LoadingButton>
        <div className="w-full">
          {list && (
            <ul className="flex flex-wrap gap-2">
              {list.map((item, index) => (
                <li
                  key={item.ServicesId}
                  className="bg-lightGreenKite text-white text-sm flex items-center justify-end gap-1 mt-2 px-2 py-1 rounded-lg"
                >
                  <span className="leading-[15px]">{item.ServicesTitle}</span>
                  <span
                    onClick={() => deleteListHandler(item.Id)}
                    className="text-white w-4 h-4 flex items-center justify-center cursor-pointer"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-4 w-4"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      strokeWidth={2}
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M6 18L18 6M6 6l12 12"
                      />
                    </svg>
                  </span>
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
    </>
  );
};

export default DefineListWithoutFormik;
